import radium from 'radium';
import '../CheckoutProcess.scss';

function NO_MATCH() {
	return (
		<div>
			<h1 className="page__headline">Ablauf nicht unterstützt</h1>
		</div>
	);
}

const RadiumNO_MATCH = radium(NO_MATCH);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumNO_MATCH.name = NO_MATCH.name

export default RadiumNO_MATCH;

